"use strict";
var requireObjectCoercible = require("../internals/require-object-coercible");
var $Object = Object;
module.exports = function(argument) {
  return $Object(requireObjectCoercible(argument));
};
